import React, { useState } from 'react';
import { Typography, Card, Divider, Button, Space } from 'antd';
import { SafetyOutlined, GlobalOutlined } from '@ant-design/icons';
import { PrivacyContentEN } from './PrivacyContentEN';
import { PrivacyContentES } from './PrivacyContentES';
import './TermsAndConditions.css';

const { Title, Text } = Typography;

const PrivacyPolicy: React.FC = () => {
  const [language, setLanguage] = useState<'en' | 'es'>('en');
  
  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'en' ? 'es' : 'en');
  };

  return (
    <div className="terms-container">
      <Card className="terms-card">
        <div className="terms-header">
          <Space orientation="vertical" size="large" style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <SafetyOutlined className="terms-icon" />
              <Button 
                icon={<GlobalOutlined />} 
                onClick={toggleLanguage}
                className="language-toggle"
              >
                {language === 'en' ? 'Español' : 'English'}
              </Button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Title level={1} className="terms-title">
                {language === 'en' 
                  ? 'Privacy Policy'
                  : 'Política de Privacidad'
                }
              </Title>
              <Text className="terms-date">
                {language === 'en' 
                  ? 'Last updated: 2025-12-13'
                  : 'Última actualización: 2025-12-13'
                }
              </Text>
            </div>
          </Space>
        </div>

        <Divider />

        {language === 'en' ? <PrivacyContentEN /> : <PrivacyContentES />}
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
